import React, { useEffect, useState } from 'react'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { useToast } from '../../controls/Toast/ToastService';
import {
    MdErrorOutline,
    MdOutlineCake,
    MdOutlineMonitorHeart,
    MdOutlineBloodtype,
    MdOutlineMonitorWeight,
    MdOutlinePhone,
    MdOutlineHome,
    MdOutlineStickyNote2,
    MdOutlineHistory,
    MdOutlineCalendarMonth,
    MdOutlineComment,
    MdPlayArrow,
} from 'react-icons/md';
import { FaClinicMedical } from 'react-icons/fa';
import useDebounce from '../../../configurations/commonlib/useDebounce';
import { useParams } from 'react-router-dom';
import { PAGE_SIZE } from '../../../configurations/initUrls';
import Paging from '../../controls/Paging';
import { IoMdOpen } from 'react-icons/io';
import { GetAll } from '../../../configurations/crud/doctorsFastNoteCurd';
import StatusContainer from '../../controls/StatusContainer';
import { ETypeBg, GetETypeName } from '../../../configurations/enums/EType';
import moment from 'moment';
import { GetEGenderName } from '../../../configurations/enums/EGender';
import useGlobalLoader from '../../../configurations/useGlobalLoader';
import Empty from '../../controls/Empty';

export default function PatientHistory({ currentData }) {
    const initValues = {
        Mobile: "",
        PageNo: 1,
        PageSize: 5,
        SearchTerm: "",
    }
    const { start, end } = useGlobalLoader()
    const [search, setSearch] = useState(initValues);
    const toast = useToast()
    const [LastPage, setLastPage] = useState(1);
    const [pagingData, setPagingData] = useState();
    const [loding, setLoding] = useState(false)
    const [userData, setUserData] = useState([]);
    const [searchDebounce, setSearchDebounce] = useDebounce("", 700);
    const [searchTerm, setSearchTerm] = useState("");
    const [patientDetails, setPatientDetails] = useState();

    useEffect(() => {
        if (currentData)
            onSearch()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search])

    const OnPageChange = (e) => {
        setSearch({ ...search, PageNo: e })
    }

    const onSearch = () => {
        GetConfirmedHistoryByMobileNo({ ...search, Mobile: currentData.mobile })
    }


    const GetConfirmedHistoryByMobileNo = (params) => {
        setLoding(true)
        start()
        opdRegisteredCrud.GetConfirmedHistoryByMobileNo({ ...params, Mobile: currentData.mobile }).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setUserData(mdata.data)
                setPagingData(mdata.paging)
                setLastPage(mdata.paging.pageCount)
            } else {
                setPagingData()
                setLastPage(1)
                setUserData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setPagingData()
            setLastPage(1)
            setUserData([])
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    return (
        <>
            {/* ===== Current patient ===== */}
            <div className="w-full p-1 sm:p-2">
                {currentData ? (
                    <div className="rounded-2xl bg-gradient-to-br from-gray-50 to-white p-4 ring-1 ring-gray-100">

                        {/* number + name */}
                        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                            <div className="flex items-center gap-3">
                                <div className="rounded-2xl bg-blue-50 px-4 py-2 text-center ring-1 ring-blue-100">
                                    <div className="text-[10px] font-semibold uppercase tracking-wide text-blue-600/70">Number</div>
                                    <div className="mt-0.5 text-2xl font-bold leading-none text-blue-700">
                                        {currentData.confirmedAllotedNumber}
                                        {currentData.confirmedAllotedNumber != currentData.opdNumberAlloted &&
                                            <span className="text-sm font-normal text-blue-400">/{currentData.opdNumberAlloted}</span>}
                                    </div>
                                </div>
                                <StatusContainer bg={ETypeBg(currentData.type)} text={GetETypeName(currentData.type)} />
                            </div>

                            <div className="sm:text-right">
                                <div className="text-[11px] uppercase tracking-wide text-gray-400">
                                    Patient <span className="normal-case">({GetEGenderName(currentData.gender)})</span>
                                </div>
                                <div className="text-xl font-bold text-gray-900">{currentData.patientName?.toUpperCase()}</div>
                                <div className="text-xs text-gray-500">
                                    Ref: {currentData.id}{currentData.registeredIdForRef && "/" + currentData.registeredIdForRef}
                                </div>
                            </div>
                        </div>

                        {/* vitals */}
                        <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-4">
                            <Stat Icon={MdOutlineCake} label="Age" value={`${currentData.age} Y`} />
                            <Stat Icon={MdOutlineMonitorHeart} label="BP" value={currentData.bloodPressure || "—"} />
                            <Stat Icon={MdOutlineBloodtype} label="Blood Group" value={currentData.bloodGroup || "—"} />
                            <Stat Icon={MdOutlineMonitorWeight} label="Weight" value={`${currentData.weight} Kg`} />
                        </div>

                        {/* contact */}
                        <div className="mt-2 grid grid-cols-1 gap-2 sm:grid-cols-2">
                            <Stat
                                Icon={MdOutlinePhone}
                                label="Phone"
                                value={
                                    currentData.mobile
                                        ? <a href={`tel:${currentData.mobile}`} className="hover:text-brand-600 hover:underline">{currentData.mobile}</a>
                                        : "—"
                                }
                            />
                            <Stat Icon={MdOutlineHome} label="Address" value={currentData.patientAddress} />
                        </div>

                        {/* note */}
                        {currentData.note &&
                            <div className="mt-3 flex items-start gap-2 rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
                                <MdOutlineStickyNote2 className="mt-0.5 shrink-0 text-lg" />
                                <div><span className="font-semibold">Note: </span>{currentData.note}</div>
                            </div>}
                    </div>
                ) : (
                    <div className="flex items-center gap-2 px-2 py-2 font-semibold">
                        <MdPlayArrow className="text-lg text-green-500" /> Please Start OPD
                    </div>
                )}
            </div>

            {/* ===== Visit history ===== */}
            <div className="mt-4 px-1 sm:px-2">
                <div className="mb-2 flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
                    <MdOutlineHistory className="text-sm" /> Visit History
                    {pagingData?.totalCount != null &&
                        <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-bold text-gray-500">{pagingData.totalCount}</span>}
                </div>

                <Paging LastPage={LastPage} CurrentPage={search.PageNo} OnPageChange={OnPageChange} pagingData={pagingData}>

                    {/* desktop table */}
                    <div className="hidden overflow-x-auto rounded-xl ring-1 ring-gray-100 sm:block">
                        <table className="w-full border-collapse text-left text-sm">
                            <thead>
                                <tr className="bg-gray-100 text-xs uppercase tracking-wide text-gray-500">
                                    <th scope="col" className="px-3 py-3 font-semibold">
                                        <span className="flex items-center gap-1"><MdOutlineCalendarMonth className="text-sm" /> Date</span>
                                    </th>
                                    <th scope="col" className="px-3 py-3 font-semibold">
                                        <span className="flex items-center gap-1"><FaClinicMedical className="text-xs" /> Center</span>
                                    </th>
                                    <th scope="col" className="px-3 py-3 font-semibold">Name</th>
                                    <th scope="col" className="px-3 py-3 font-semibold">
                                        <span className="flex items-center gap-1"><MdOutlineComment className="text-sm" /> Comment</span>
                                    </th>
                                    <th scope="col" className="px-3 py-3 font-semibold">
                                        <span className="flex items-center gap-1"><MdOutlineStickyNote2 className="text-sm" /> Note</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-100">
                                {userData.length > 0 ? (
                                    userData.map((item, index) => (
                                        <tr key={item.id ?? index} className="bg-white hover:bg-gray-50">
                                            <td className="whitespace-nowrap px-3 py-2.5 text-gray-700">{moment(item.onDate).format("DD-MM-YYYY")}</td>
                                            <td className="whitespace-nowrap px-3 py-2.5 text-gray-700">{item.opdCenter.centerName}</td>
                                            <td className="whitespace-nowrap px-3 py-2.5 text-gray-700">
                                                {item.patientName} <span className="text-xs text-gray-400">(BP:{item.bloodPressure} W:{item.weight}Kg)</span>
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-2.5 text-gray-700">{item.acceptedWithComment ? item.acceptedWithComment : "N/A"}</td>
                                            <td className="text-nowrap px-3 py-2.5 text-gray-700">{item.note}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr className="bg-white">
                                        <td colSpan={5} className="px-3 py-2">
                                            <Empty>No Items Found.</Empty>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* mobile cards */}
                    <div className="space-y-2 text-left sm:hidden">
                        {userData.length > 0 ? (
                            userData.map((item, index) => (
                                <div key={item.id ?? index} className="rounded-xl border border-gray-100 bg-white p-3 text-sm shadow-sm">
                                    <div className="flex items-center justify-between gap-2">
                                        <span className="font-semibold text-gray-800">{item.patientName}</span>
                                        <span className="flex shrink-0 items-center gap-1 text-xs text-gray-400">
                                            <MdOutlineCalendarMonth className="text-sm" />
                                            {moment(item.onDate).format("DD-MM-YYYY")}
                                        </span>
                                    </div>
                                    <div className="mt-1 flex items-center gap-1 text-xs text-gray-500">
                                        <FaClinicMedical className="shrink-0 text-[10px]" />
                                        {item.opdCenter.centerName}
                                    </div>
                                    <div className="mt-1 flex items-center gap-2 text-xs text-gray-600">
                                        <span className="flex items-center gap-1"><MdOutlineMonitorHeart className="text-sm text-gray-400" /> {item.bloodPressure}</span>
                                        <span className="flex items-center gap-1"><MdOutlineMonitorWeight className="text-sm text-gray-400" /> {item.weight}Kg</span>
                                    </div>
                                    <div className="mt-1 flex items-start gap-1 text-xs text-gray-600">
                                        <MdOutlineComment className="mt-0.5 shrink-0 text-sm text-gray-400" />
                                        <span>{item.acceptedWithComment ? item.acceptedWithComment : "N/A"}</span>
                                    </div>
                                    {item.note &&
                                        <div className="mt-1 flex items-start gap-1 text-xs text-gray-600">
                                            <MdOutlineStickyNote2 className="mt-0.5 shrink-0 text-sm text-gray-400" />
                                            <span>{item.note}</span>
                                        </div>}
                                </div>
                            ))
                        ) : (
                            <Empty>No Items Found.</Empty>
                        )}
                    </div>
                </Paging>

                <div className="pb-4" />
            </div>
        </>
    )
}

/* ---------- helper ---------- */
function Stat({ Icon, label, value }) {
    return (
        <div className="rounded-xl bg-white p-3 ring-1 ring-gray-100">
            <div className="flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wide text-gray-400">
                {Icon && <Icon className="shrink-0 text-sm" />}
                <span>{label}</span>
            </div>
            <div className="mt-0.5 break-words text-sm font-bold text-gray-800">{value}</div>
        </div>
    )
}